//
// ViewManager.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "./moduleBuilder";
import ClosetObject from "./ClosetObject";
import "./lib";
import "./RenderMode";

var ViewManager = createModule("commons::ViewManager", [], ClosetObject, [
    ,
    ,
    ,
    ,
    ,
    {
        getGlobalRenderMode: [4],
        removeView: [0,1],
        invalidateAllViews: [0],
        refreshAllViews: [0],
        renderAllViews: [0],
        addView: [0,1,7,4],
        appendCanvasToContainer: [0,7],
    },
    ,
]);
export default ViewManager;
